"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const PropTypes = __importStar(require("prop-types"));
class ContextProvider extends React.Component {
    getChildContext() {
        return { requestContext: this.props.requestContext };
    }
    render() {
        return React.createElement("div", null, this.props.children);
    }
}
ContextProvider.childContextTypes = {
    requestContext: PropTypes.object
};
exports.ContextProvider = ContextProvider;
function withContext(C) {
    const consumer = (p, { requestContext }) => {
        if (requestContext == null) {
            throw new Error("no request context in React context");
        }
        return React.createElement(C, Object.assign({}, p, { requestContext: requestContext }));
    };
    consumer.contextTypes = {
        requestContext: PropTypes.object
    };
    return consumer;
}
exports.withContext = withContext;
//# sourceMappingURL=ContextProvider.js.map